import styled from 'styled-components';

import { rem } from '../../../../helpers';

export const $FilterWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding: ${rem(8)} 0 ${rem(16)};
  &:last-child {
    border-bottom: none;
  }
`;

export const $FilterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 0;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};
  min-height: ${rem(40)};
  border-radius: ${({ theme }) => theme.borders.radius};

  transition: border-color 150ms ease;
  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const $FilterSelectedValues = styled.div`
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const $FilterSelectedDatePicker = styled.div`
  width: 100%;

  && .react-datepicker-popper {
    z-index: 20 !important;
  }
`;

export const $FilterContentRightBlock = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const $FilterMenuContainer = styled.div<{
  $hasPaddingX?: boolean;
}>`
  position: relative;
  min-height: ${rem(40)};
  height: auto;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};

  padding: 0 ${({ $hasPaddingX }) => ($hasPaddingX ? rem(16) : 0)};

  display: block;
`;

export const $FilterSelectedSlider = styled.div`
  width: 100%;
`;
